import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center justify-center min-h-screen"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "material-icons-outlined opacity-10 mx-auto",
  style: {"font-size":"8rem","line-height":"1"}
}, " error_outline ", -1)
const _hoisted_5 = { class: "opacity-40 mt-4 text-center" }
const _hoisted_6 = { class: "text-muted mt-2 text-center" }
const _hoisted_7 = {
  key: 2,
  class: "max-w-6xl mx-auto px-4 md:px-6 py-6"
}
const _hoisted_8 = { class: "card card-border mb-6 p-5 md:p-6" }
const _hoisted_9 = { class: "flex items-start justify-between gap-4 mb-4" }
const _hoisted_10 = { class: "min-w-0" }
const _hoisted_11 = { class: "mb-1 truncate" }
const _hoisted_12 = { class: "text-right shrink-0" }
const _hoisted_13 = { class: "text-2xl font-semibold text-primary" }
const _hoisted_14 = { class: "text-sm text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-wrap gap-2 mt-4"
}
const _hoisted_16 = { class: "material-icons-outlined text-sm mr-1" }
const _hoisted_17 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-6" }
const _hoisted_18 = { class: "lg:col-span-3" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "space-y-4" }
const _hoisted_21 = { class: "flex items-center justify-between px-5 pt-5 pb-4 gap-3" }
const _hoisted_22 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_23 = { class: "min-w-0" }
const _hoisted_24 = { class: "mb-0 truncate" }
const _hoisted_25 = { class: "text-sm text-muted" }
const _hoisted_26 = { class: "px-5 space-y-1" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "material-icons-outlined text-success shrink-0",
  style: {"font-size":"22px"}
}
const _hoisted_29 = {
  key: 1,
  class: "material-icons-outlined text-primary shrink-0",
  style: {"font-size":"22px"}
}
const _hoisted_30 = {
  key: 2,
  class: "material-icons-outlined text-muted shrink-0",
  style: {"font-size":"22px","opacity":"0.4"}
}
const _hoisted_31 = { class: "flex-1 min-w-0" }
const _hoisted_32 = { class: "font-medium truncate" }
const _hoisted_33 = {
  key: 0,
  class: "text-xs text-muted"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-muted shrink-0 opacity-40",
  style: {"font-size":"18px"}
}, " chevron_right ", -1)
const _hoisted_35 = { class: "px-5 pb-5 pt-4 mt-1 border-t border-gray-100 flex items-center justify-end gap-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"15px"}
}, " lock ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"15px"}
}, " quiz ", -1)
const _hoisted_38 = { class: "lg:col-span-1 space-y-4" }
const _hoisted_39 = { class: "card card-border p-5" }
const _hoisted_40 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-primary",
  style: {"font-size":"20px"}
}, " fitness_center ", -1)
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = { class: "text-sm text-muted mb-4" }
const _hoisted_44 = {
  key: 1,
  class: "card card-border p-5"
}
const _hoisted_45 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-primary",
  style: {"font-size":"20px"}
}, " leaderboard ", -1)
const _hoisted_47 = { class: "mb-0" }
const _hoisted_48 = {
  key: 2,
  class: "card card-border p-5"
}
const _hoisted_49 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-primary",
  style: {"font-size":"20px"}
}, " emoji_events ", -1)
const _hoisted_51 = { class: "mb-0" }
const _hoisted_52 = { class: "space-y-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-primary shrink-0",
  style: {"font-size":"20px"}
}, " star ", -1)
const _hoisted_54 = { class: "min-w-0" }
const _hoisted_55 = { class: "font-medium text-sm truncate" }
const _hoisted_56 = { class: "text-xs text-muted" }

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useProgressStore } from "@/stores/progressStore";
import { usePublicCourseStore } from "@/stores/publicCourseStore";
import type { TopicNode, LessonNode } from "@/models/interfaces";
import Spinner from "@/components/ui/Spinner.vue";
import LinearProgress from "@/components/ui/LinearProgress.vue";
import Btn from "@/components/ui/Btn.vue";
import Tooltip from "@/components/ui/Tooltip.vue";
import PublicGamificationLeaderboard from "@/components/public/PublicGamificationLeaderboard.vue";
import UserGamificationCard from "@/components/public/UserGamificationCard.vue";
import GamificationRewardToast from "@/components/ui/GamificationRewardToast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LearningJourney',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const progressStore = useProgressStore();
const publicCourseStore = usePublicCourseStore();

const loading = ref(true);
const error = ref<string | null>(null);
const slug = route.params.slug as string;

const organizedContent = computed(() => publicCourseStore.currentCourseContent);
const course = computed(() => publicCourseStore.enrolledCourse);
const userProgress = computed(() => progressStore.userProgress);
const learningPath = computed(() => progressStore.learningPath);
const showRewardToast = computed(() => progressStore.showRewardToast);
const pendingGamificationEvents = computed(() => progressStore.pendingGamificationEvents);
const handleRewardDismissed = () => progressStore.clearRewardToast();

const loadLearningJourney = async () => {
	loading.value = true;
	error.value = null;
	try {
		const courseData = await publicCourseStore.loadPublicCourse(slug);
		publicCourseStore.enrolledCourse = courseData.course;

		if (publicCourseStore.courseId) {
			await Promise.all([
				publicCourseStore.loadCourseContent(publicCourseStore.courseId),
				progressStore.initializeProgress(publicCourseStore.courseId),
			]);
			progressStore.setCourseContent(publicCourseStore.currentCourseContent);
		} else {
			throw new Error("Course not found or not enrolled");
		}
	} catch (err: any) {
		console.error("Failed to load learning journey:", err);
		error.value = err.message || "Unable to load course content";
	} finally {
		loading.value = false;
	}
};

onMounted(loadLearningJourney);

// ── Lesson helpers ──────────────────────────────────────────
const isLessonCompleted = (nodeId: string) => progressStore.isNodeCompleted(nodeId);
const isLessonCurrent = (nodeId: string) => progressStore.currentLesson?.id === nodeId;

const getTopicProgress = (topic: TopicNode & { lessons: LessonNode[] }): string => {
	const done = topic.lessons.filter(l => isLessonCompleted(l.id)).length;
	return `${done}/${topic.lessons.length}`;
};

const isTopicComplete = (topic: TopicNode & { lessons: LessonNode[] }): boolean => {
	return topic.lessons.length > 0 && topic.lessons.every(l => isLessonCompleted(l.id));
};

const topicBadgeClass = (topic: TopicNode & { lessons: LessonNode[] }): string => {
	if (isTopicComplete(topic)) return "bg-success bg-opacity-15 text-success-dark";
	const done = topic.lessons.filter(l => isLessonCompleted(l.id)).length;
	if (done > 0) return "bg-primary bg-opacity-15 text-primary";
	return "bg-gray-100 text-muted";
};

const lessonRowClass = (lesson: LessonNode): string => {
	if (isLessonCompleted(lesson.id)) return "opacity-75";
	if (isLessonCurrent(lesson.id)) return "bg-primary bg-opacity-5";
	return "";
};

// ── Navigation ───────────────────────────────────────────────
const openLesson = (lesson: LessonNode) => router.push(`/c/${slug}/lesson/${lesson.id}`);
const startTopicQuiz = (topicId: string) => router.push(`/c/${slug}/quiz/${topicId}`);
const retryLoading = () => loadLearningJourney();

const goToPractice = () => router.push(`/c/${slug}/practice`);

const handleAction = (action: any) => {
	if (!action.node_id) return;
	if (action.type === "lesson") router.push(`/c/${slug}/lesson/${action.node_id}`);
	else if (action.type === "quiz") router.push(`/c/${slug}/quiz/${action.node_id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, {
            size: "xl",
            variant: "primary"
          })
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("learning_journey.loading_error")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(error.value), 1),
            _createVNode(Btn, {
              onClick: retryLoading,
              variant: "primary",
              class: "mt-6"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("learning_journey.retry")), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h1", _hoisted_11, _toDisplayString(_unref(course)?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(Math.round(_unref(userProgress)?.overall_progress_percentage || 0)) + "% ", 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("learning_journey.complete")), 1)
                ])
              ]),
              _createVNode(LinearProgress, {
                progress: _unref(userProgress)?.overall_progress_percentage || 0
              }, null, 8, ["progress"]),
              (_unref(learningPath)?.suggested_next_actions?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(learningPath).suggested_next_actions, (action) => {
                      return (_openBlock(), _createBlock(Btn, {
                        key: action.description,
                        onClick: ($event: any) => (handleAction(action)),
                        variant: "secondary",
                        size: "sm"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(action.type === "quiz" ? "quiz" : "play_arrow"), 1),
                          _createTextVNode(" " + _toDisplayString(action.description), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t("learning_journey.learning_path")), 1),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizedContent), (topic, topicIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: topic.id,
                      class: "card card-border overflow-hidden"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["w-8 h-8 rounded-full shrink-0 flex items-center justify-center text-sm font-semibold", topicBadgeClass(topic)])
                          }, _toDisplayString(topicIndex + 1), 3),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("h3", _hoisted_24, _toDisplayString(topic.name), 1),
                            _createElementVNode("p", _hoisted_25, _toDisplayString(getTopicProgress(topic)) + " " + _toDisplayString(_ctx.$t("learning_journey.lessons_completed").toLowerCase()), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.lessons, (lesson) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: lesson.id,
                            onClick: ($event: any) => (openLesson(lesson)),
                            class: _normalizeClass(["flex items-center gap-3 p-3 rounded cursor-pointer transition-colors hover:bg-light", lessonRowClass(lesson)])
                          }, [
                            (isLessonCompleted(lesson.id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, " check_circle "))
                              : (isLessonCurrent(lesson.id))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, " play_circle "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_30, " radio_button_unchecked ")),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("p", _hoisted_32, _toDisplayString(lesson.title), 1),
                              (lesson.estimated_duration_minutes)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(lesson.estimated_duration_minutes) + " " + _toDisplayString(_ctx.$t("learning_journey.min")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_34
                          ], 10, _hoisted_27))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (!isTopicComplete(topic))
                          ? (_openBlock(), _createBlock(Tooltip, {
                              key: 0,
                              textValue: _ctx.$t('learning_journey.topic_quiz_locked'),
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Btn, {
                                  variant: "secondary",
                                  size: "xs",
                                  disabled: true
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_36,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.topic_quiz")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["textValue"]))
                          : (_openBlock(), _createBlock(Btn, {
                              key: 1,
                              onClick: _withModifiers(($event: any) => (startTopicQuiz(topic.id)), ["stop"]),
                              variant: "secondary",
                              size: "xs"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_37,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.topic_quiz")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("h3", _hoisted_42, _toDisplayString(_ctx.$t("learning_journey.free_practice")), 1)
                  ]),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("learning_journey.free_practice_description")), 1),
                  _createVNode(Btn, {
                    onClick: goToPractice,
                    variant: "primary-borderless",
                    size: "sm",
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("learning_journey.go_to_practice")), 1)
                    ]),
                    _: 1
                  })
                ]),
                (_unref(publicCourseStore).courseId)
                  ? (_openBlock(), _createBlock(UserGamificationCard, {
                      key: 0,
                      "course-id": _unref(publicCourseStore).courseId
                    }, null, 8, ["course-id"]))
                  : _createCommentVNode("", true),
                (_unref(publicCourseStore).courseId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.$t("learning_journey.leaderboard")), 1)
                      ]),
                      _createVNode(PublicGamificationLeaderboard, {
                        "course-id": _unref(publicCourseStore).courseId
                      }, null, 8, ["course-id"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(learningPath)?.achievements?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("h3", _hoisted_51, _toDisplayString(_ctx.$t("learning_journey.recent_achievements")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(learningPath).achievements.slice(0, 3), (achievement) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: achievement.title,
                            class: "flex items-center gap-3 p-2 bg-light rounded"
                          }, [
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("p", _hoisted_55, _toDisplayString(achievement.title), 1),
                              _createElementVNode("p", _hoisted_56, _toDisplayString(achievement.description), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
    _createVNode(GamificationRewardToast, {
      events: _unref(pendingGamificationEvents),
      visible: _unref(showRewardToast),
      onDismissed: handleRewardDismissed
    }, null, 8, ["events", "visible"])
  ]))
}
}

})